// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1959":"67a947e8c256c5b4","3232":"535713941ffe8f82","3791":"be0230a76836c198","9059":"535713941ffe8f82","9365":"67a947e8c256c5b4"}[chunkId] + ".css";
};